import axios from 'axios';
import { setOnScreenEls, checkOnScreenEls } from '../common/on-screen';

import '../../sass/blocks/jobs-list.scss';

( () => {
    const filterJobsListAction = 'chadsan_theme_filter_jobs_list';

    const $jobsLists = document.querySelectorAll('.jobs-list');

    if ( !$jobsLists ) return;

    $jobsLists.forEach( $jobsList => {
        const $filterForm = $jobsList.querySelector('.jobs-list__filter');
        const $locationSelect = $jobsList.querySelector('.jobs-list__search-location-select');
        const $list = $jobsList.querySelector('.jobs-list__list');
        const $noJobsMessage = $jobsList.querySelector('.jobs-list__no-jobs');

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        
        const filterJobsList = () => {
            if ( !GLOBALS?.AJAX_URL ) return;

            const { nonce } = $list.dataset;

            const location = $locationSelect.value;

            axios.get( GLOBALS.AJAX_URL, {
                cancelToken: source.token,
                params: {
                    action: filterJobsListAction,
                    nonce: nonce,
                    location: location
                }
            } ).then( response => {
                const url = new URL(window.location.href);
                const searchParams = url.searchParams;

                if ( response.data.html ) {
                    if ($noJobsMessage) {
                        $noJobsMessage.classList.remove('show');
                    }
                    
                    $list.innerHTML = response.data.html;
                } else {
                    if ($noJobsMessage) {
                        $noJobsMessage.classList.add('show');
                    }

                    $list.innerHTML = '';
                }

                setOnScreenEls();
                checkOnScreenEls();

                $list.dataset.location = response?.data?.location ?? '';

                searchParams.set('location', response?.data?.location ?? '');
                searchParams.set('block_id', $jobsList.id);

                window.history.replaceState('', '', url.toString());
            } ).catch( error => {
                console.log(error?.response);
            } ).finally( () => {
                $list.classList.remove('loading');
            } );
        };

        const initFilter = () => {
            if ( !$filterForm || !$locationSelect ) return;

            let searchTimeout;

            const submitFilterJobsListForm = () => {
                clearTimeout(searchTimeout);

                $list.classList.add('loading');

                searchTimeout = setTimeout( () => {
                    const { teamMemberGroup } = $list.dataset;

                    filterJobsList();
                }, 500 );
            }

            $locationSelect.addEventListener('change', () => {
                submitFilterJobsListForm();
            } );

            $filterForm.addEventListener('submit', e => {
                e.preventDefault();
                
                submitFilterJobsListForm();
            } );
        };

        initFilter();
    } );
} )();
